/* eslint-disable-next-line  no-unused-vars */
import React, { createElement } from 'react';

export default function mapLoader() {
    const open = () => {
        let doc = document.getElementById('oem-gis-loader');
        doc.hidden = false;
    };

    const close = () => {
        let doc = document.getElementById('oem-gis-loader');
        doc.hidden = true;
    };

    return { open, close };
}
